import { useDataFetch } from '../../../hooks/use-data-fetch';

interface OrderItem {
  product_id: {
    _id: string;
    title: string;
    images: string[];
    mainImage: number;
  };
  quantity: number;
  loyalty_points: number;
  influencer_bonus: number;
  price: number;
}

interface Order {
  _id?: string;
  id?: string;
  user_id: {
    id: string;
    name: string;
    email: string;
    photo?: string;
  };
  items: OrderItem[];
  total: number;
  currency: string;
  status: string;
  created_at: string;
  loyalty_points_total: number;
}

export const useOrdersByIds = (orderIds: string[], enabled: boolean = false) => {
  const { getData } = useDataFetch();

  const { data, isLoading, error, refetch } = getData(
    ['orders-by-ids', orderIds.join(',')],
    '/order/byOrders/ids',
    {
      enabled: enabled && orderIds.length > 0,
    },
    {
      ids: orderIds.join(',')
    }
  );

  const orders: Order[] = data?.data?.orders || [];

  // Calcular totales por usuario
  const getUserTotals = () => {
    const userTotals: Record<string, {
      user: Order['user_id'];
      totalPoints: number;
      totalValue: number;
      orderCount: number;
      orders: Order[];
    }> = {};


    // Validar que orders sea un array antes de usar forEach
    if (!Array.isArray(orders) || orders.length === 0) {
      return [];
    }

    orders.forEach(order => {
      console.log("order", order);
      // Validar que la orden tenga la estructura esperada
      if (!order || !order.user_id || !order.user_id.id) {
        return;
      }

      console.log("order", order);

      const userId = order.user_id.id;
      
      if (!userTotals[userId]) {
        userTotals[userId] = {
          user: order.user_id,
          totalPoints: 0,
          totalValue: 0,
          orderCount: 0,
          orders: []
        };
      }

      userTotals[userId].totalPoints += order.loyalty_points_total || 0;
      userTotals[userId].totalValue += order.total || 0;
      userTotals[userId].orderCount += 1;
      userTotals[userId].orders.push(order);
    });

    return Object.values(userTotals);
  };

  // Calcular totales generales
  const getTotals = () => {
    // Validar que orders sea un array antes de usar reduce
    if (!Array.isArray(orders) || orders.length === 0) {
      return { totalPoints: 0, totalValue: 0, totalOrders: 0 };
    }

    return orders.reduce(
      (acc, order) => ({
        totalPoints: acc.totalPoints + (order.loyalty_points_total || 0),
        totalValue: acc.totalValue + (order.total || 0),
        totalOrders: acc.totalOrders + 1
      }),
      { totalPoints: 0, totalValue: 0, totalOrders: 0 }
    );
  };

  return {
    orders,
    isLoading,
    error,
    refetch,
    userTotals: getUserTotals(),
    totals: getTotals()
  };
};
